/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { BorrowerEscrowAnalysisProvider } from '../contexts/BorrowerEscrowAnalysisContext';
import EnvelopeWithBox from '../components/EnvelopeWithBox';
import BorrowerEscrowAnalysis from '../components/forms/BorrowerEscrowAnalysis';
import ServicerEscrowAnalysis from '../components/forms/ServicerEscrowAnalysis';
import { ServicerEscrowAnalysisProvider } from '../contexts/ServicerEscrowAnalysisContext';
import { useViewingContext } from '../contexts/ViewingContext';

const EscrowAnalysisPage = () => {
  const { isServicerView } = useViewingContext();
  return isServicerView ? (
    <ServicerEscrowAnalysisProvider>
      <EnvelopeWithBox blockName='Escrow Analysis'>
        <ServicerEscrowAnalysis />
      </EnvelopeWithBox>
    </ServicerEscrowAnalysisProvider>
  ) : (
    <BorrowerEscrowAnalysisProvider>
      <EnvelopeWithBox blockName='Escrow Analysis'>
        <BorrowerEscrowAnalysis />
      </EnvelopeWithBox>
    </BorrowerEscrowAnalysisProvider>
  );
};

export default EscrowAnalysisPage;
